import { formRules } from "../../../../../config/validations/formRules";

export const rules: any = {
  name: () => formRules.name(),
};
